<template>
  <v-container class="day-schedule-list" fluid>
    <v-row>
      <v-col>
        <DayScheduleTimeLine v-model="sessions"
                             @click:event="sessionClicked"></DayScheduleTimeLine>
        <div class="day-schedule-select-schedule-overlay" v-if="!editingDaySchedule.id">
          <div class="text-center">{{ $t('admin_acc_day_schedule.select_schedule') }}</div>
        </div>
        <v-menu v-model="sessionMenuOpened"
                offset-x
                :close-on-content-click="false"
                :activator="selectedSessionTarget">
          <v-card outlined v-if="selectedSession" style="border-width: 2px; border-color: #333;">
            <v-card-title>{{ $t('admin_acc_day_schedule.add_title') }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <TimeInput v-model="selectedSessionFromTime"></TimeInput>
                </v-col>
                <v-col>
                  <TimeInput v-model="selectedSessionToTime"></TimeInput>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select outlined
                            :label="$t('admin_acc_facility_type.price_tiers')"
                            :placeholder="$t('admin_acc_facility_type.price_tiers')"
                            :items="priceTierOptions"
                            v-model="selectedSession.price_tier"></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="red"
                     @click="deleteSession">
                {{ $t('delete') }}
              </v-btn>
              <v-btn text color="#2bc7ca"
                     @click="editSession">
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            {{ $t('admin_acc_facility_type.day_schedule') }}
          </v-col>
          <v-col class="text-right">
            <v-menu v-model="addDayScheduleMenuOpened"
                    :close-on-content-click="false"
                    left
                    offset-x>
              <template v-slot:activator="{on, attrs}">
                <v-btn small
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>fas fa-plus</v-icon>
                </v-btn>
              </template>

              <v-card outlined>
                <v-card-title>{{ $t('admin_acc_day_schedule.add_title') }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field outlined
                                    :label="$t('admin_acc_day_schedule.name')"
                                    :placeholder="$t('admin_acc_day_schedule.name')"
                                    v-model="addingDayScheduleName">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="#2bc7ca"
                         @click="addDayScheduleMenuOpened = false">
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn text color="#2bc7ca"
                         @click="addDaySchedule">
                    {{ $t('save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-data-table :items="daySchedules"
                      :headers="dayScheduleHeaders"
                      item-class="day-schedule-list-table-body"
                      hide-default-footer>
          <template v-slot:item.actions="data">
            <font-awesome-icon icon="edit"
                               class="mr-3"
                               @click.stop="editDaySchedule(data.item)"></font-awesome-icon>
            <font-awesome-icon icon="copy"
                               class="mr-3"
                               @click.stop="copyDaySchedule(data.item)"></font-awesome-icon>
            <font-awesome-icon icon="trash"
                               @click.stop="deleteDaySchedule(data.item)"></font-awesome-icon>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-container v-if="editingDaySchedule.id">
          <v-row>
            <v-col>{{ $t('admin_acc_day_schedule.edit_title') }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_acc_day_schedule.name')"
                            :placeholder="$t('admin_acc_day_schedule.name')"
                            v-model="editingDaySchedule.name">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-btn color="#dddddd" @click="resetDaySchedule" class="mr-3">
                {{ $t('reset') }}
              </v-btn>
              <v-btn color="#2bc7ca" @click="saveDaySchedule">
                {{ $t('save') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>{{ $t('admin_acc_day_schedule.add_session_title') }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              <TimeInput v-model="sessionFromTime"></TimeInput>
            </v-col>
            <v-col>
              <TimeInput v-model="sessionToTime"></TimeInput>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select outlined
                        :label="$t('admin_acc_facility_type.price_tiers')"
                        :placeholder="$t('admin_acc_facility_type.price_tiers')"
                        :items="priceTierOptions"
                        v-model="selectedPriceTier"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-btn color="#2bc7ca"
                     :disabled="!selectedPriceTier || !sessionFromTime || !sessionToTime"
                     @click="addSession">
                {{ $t('add') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import TimeInput from "@/components/TimeInput";
import DayScheduleTimeLine from "@/components/DayScheduleTimeline";
import _ from 'lodash';

const uuid4 = require('uuid/v4');

export default {
  name: 'DayScheduleList',
  components: {DayScheduleTimeLine, TimeInput},
  props: {
    typeId: String,
  },
  setup(props, {root}) {
    const priceTiers = ref([]);
    const getPriceTiers = function () {
      root.$callAPI('room/admin/item_type/price_tier/', {
        type_id: props.typeId,
      }, function (response) {
        priceTiers.value = response.body.price_tiers;
      });
    };
    const priceTierOptions = computed(() => {
      return priceTiers.value.map((p) => {
        return {text: p.name, value: p};
      })
    });

    const sessions = ref([]);
    const sessionMenuOpened = ref(false);
    const selectedSession = ref(null);
    const selectedSessionFromTime = ref(null);
    const selectedSessionToTime = ref(null);
    const selectedSessionTarget = ref(null);
    const sessionClicked = function ({event, nativeEvent}) {
      let session = null;

      sessions.value.forEach((s) => {
        if (s.id === event.id) {
          session = s;
        }
      });

      const open = () => {
        let fromTime = new Date(session.start);
        let toTime = new Date(session.end);

        selectedSession.value = session;
        selectedSessionFromTime.value = `${fromTime.getHours().toString().padStart(2, '0')}:${fromTime.getMinutes().toString().padStart(2, '0')}`;
        selectedSessionToTime.value = `${toTime.getHours().toString().padStart(2, '0')}:${toTime.getMinutes().toString().padStart(2, '0')}`;
        selectedSessionTarget.value = nativeEvent.target
        setTimeout(() => sessionMenuOpened.value = true, 10)
      }

      if (sessionMenuOpened.value) {
        sessionMenuOpened.value = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation();
    };
    const deleteSession = function () {
      let newSessions = sessions.value;
      let index = -1;
      newSessions.forEach((s, idx) => {
        if (s.id === selectedSession.value.id) {
          index = idx;
        }
      });

      newSessions.splice(index, 1);

      sessions.value = newSessions;

      sessionMenuOpened.value = false;
    };
    const editSession = function () {
      let newSessions = sessions.value;

      let newSessionStartTime = `2000-01-01 ${selectedSessionFromTime.value}`;
      let newSessionEndTime = `2000-01-01 ${selectedSessionToTime.value}`;

      let noOverlap = true;

      // Check for overlap
      newSessions.forEach((s) => {
        if (s.id !== selectedSession.value.id && ((newSessionStartTime < s.end && newSessionEndTime > s.start) ||
            (newSessionStartTime === s.start && newSessionEndTime === s.end))) {
          noOverlap = false;
        }
      });

      if (noOverlap) {
        newSessions.forEach((s) => {
          if (s.id === selectedSession.value.id) {
            s.name = selectedSession.value.price_tier.name;
            s.price_tier = selectedSession.value.price_tier;
            s.start = newSessionStartTime;
            s.end = newSessionEndTime;
          }
        });

        sessions.value = newSessions;

        sessionMenuOpened.value = false;
      } else {
        alert('Overlapping Sessions');
      }
    };

    const sessionFromTime = ref(null);
    const sessionToTime = ref(null);
    const selectedPriceTier = ref(null);
    const addSession = function () {
      let fromTimestamp = `2000-01-01 ${sessionFromTime.value}`;
      let toTimestamp = `2000-01-01 ${sessionToTime.value}`;
      // Overnight
      if (fromTimestamp > toTimestamp) {
        toTimestamp = `2000-01-02 ${sessionToTime.value}`;
      }
      let newSessions = sessions.value;

      if (_.some(newSessions, (e) => {
        return (fromTimestamp < e.end && toTimestamp > e.start) ||
            (fromTimestamp === e.start && toTimestamp === e.end);
      })) {
        alert('Overlapping Sessions');
        return;
      }

      newSessions.push({
        id: uuid4(),
        name: selectedPriceTier.value.name,
        price_tier: selectedPriceTier.value,
        start: fromTimestamp,
        end: toTimestamp,
      });
      sessions.value = newSessions;
    };

    // Day Schedule
    const daySchedules = ref([]);
    const getDaySchedules = function () {
      root.$callAPI('room/admin/item_type/day_schedule/', {
        type_id: props.typeId,
      }, function (response) {
        daySchedules.value = response.body.day_schedules;
      });
    };
    const dayScheduleHeaders = [
      {text: root.$t('admin_acc_day_schedule.name'), value: 'name'},
      {text: '', value: 'actions', align: 'end'},
    ];

    const addDayScheduleMenuOpened = ref(false);
    const addingDayScheduleName = ref('');
    const addDaySchedule = function () {
      root.$callAPI('room/admin/item_type/day_schedule/set/', {
        type_id: props.typeId,
        name: addingDayScheduleName.value,
        sessions: '[]',
      }, function (response) {
        addDayScheduleMenuOpened.value = false;
        addingDayScheduleName.value = '';
        getDaySchedules();
      });
    };

    const editingDaySchedule = ref({id: null, events: []});
    const editDaySchedule = function (item) {
      editingDaySchedule.value = item;
      sessions.value = JSON.parse(item.sessions) || [];
    };
    const copyDaySchedule = function (item) {
      let newDaySchedule = {
        type_id: item.item_type,
        name: `${item.name} (Copy)`,
        sessions: JSON.stringify(JSON.parse(item.sessions).map((s)=> {
          return {
            ...s,
            id: uuid4(),
          }
        })),
      };

      root.$callAPI('room/admin/item_type/day_schedule/set/', newDaySchedule, function (response) {
        getDaySchedules();
      });
    };
    const resetDaySchedule = function () {
      editingDaySchedule.value = {};
      sessions.value = [];
    };
    const deleteDaySchedule = function (item) {
      if (confirm(root.$t('admin_acc_day_schedule.confirm_delete'))) {
        root.$callAPI('room/admin/item_type/day_schedule/delete/', {
          id: item.id,
        }, function (response) {
          resetDaySchedule();
          getDaySchedules();
        });
      }
    };
    const saveDaySchedule = function () {
      root.$callAPI('room/admin/item_type/day_schedule/set/', {
        ...editingDaySchedule.value,
        type_id: props.typeId,
        sessions: JSON.stringify(sessions.value),
      }, function (response) {
        getDaySchedules();
      });
    };

    onMounted(() => {
      getPriceTiers();
      getDaySchedules();
    })

    return {
      priceTiers,
      priceTierOptions,

      sessions,
      sessionMenuOpened,
      selectedSession,
      selectedSessionFromTime,
      selectedSessionToTime,
      selectedSessionTarget,
      sessionClicked,
      deleteSession,
      editSession,

      sessionFromTime,
      sessionToTime,
      selectedPriceTier,
      addSession,

      daySchedules,
      dayScheduleHeaders,

      addDayScheduleMenuOpened,
      addingDayScheduleName,
      addDaySchedule,

      editingDaySchedule,
      editDaySchedule,
      copyDaySchedule,
      deleteDaySchedule,
      resetDaySchedule,
      saveDaySchedule,
    };
  },
}
</script>

<style lang="less">
.day-schedule-list {
  .day-schedule-select-schedule-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    div {
      font-size: 120%;
      font-weight: bold;
      color: white;
      padding-top: 60px;
    }
  }

  .day-schedule-list-table-body {
    svg {
      font-size: 1.5em;
      margin-left: 5px;
    }

    .fa-edit, .fa-trash {
      cursor: pointer;

      &:hover {
        color: #0070ff;
      }
    }
  }
}
</style>
